import React from 'react'
import { PrimaryButtonView } from 'components'

export default ({ saving, disabled }) => (
  <PrimaryButtonView
    disabled={disabled}
    label={saving ? 'PROCESSING' : 'SUBMIT'}
  />
)
